import SelectedProductsListItem from './SelectedProductsListItem';

export default SelectedProductsListItem;
